import React from 'react'
import { Button, Flex, Typography } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useUnanswered } from '../hooks'

export type SiteAttentionProps = {
    siteId: string
    days: 7 | 30
    onAnswer: () => void
}

/**
 * The questions Evaa could not answer in the chosen period, in one line: how many, the most asked one, and a button to
 * answer them one by one in the inbox.
 */
export function SiteAttention({ siteId, days, onAnswer }: SiteAttentionProps) {
    const { t } = useTranslation()
    const { data } = useUnanswered(siteId, days)
    const top = data?.data[0]
    const total = data?.meta.total ?? 0

    if (!top) {
        return null
    }

    return (
        <Flex
            align="center"
            justify="space-between"
            gap="middle"
            className="rounded-xl border border-neutral-200 bg-white px-4 py-3"
        >
            <Typography.Text className="min-w-0 truncate">
                <QuestionCircleOutlined className="mr-2 text-orange-500" />
                {t('{{count}} questions Evaa could not answer', { count: total })}
                <Typography.Text type="secondary">
                    {' · '}
                    {t('most asked: “{{question}}” ({{count}}×)', { question: top.question, count: top.count })}
                </Typography.Text>
            </Typography.Text>
            <Button
                type="primary"
                className="shrink-0"
                onClick={onAnswer}
            >
                {t('Answer questions')}
            </Button>
        </Flex>
    )
}
